import { render, staticRenderFns } from "./OsmMap.vue?vue&type=template&id=4fdb2742&scoped=true"
import script from "./OsmMap.vue?vue&type=script&lang=ts"
export * from "./OsmMap.vue?vue&type=script&lang=ts"
import style0 from "./OsmMap.vue?vue&type=style&index=0&id=4fdb2742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdb2742",
  null
  
)

export default component.exports